import React from "react";
import InfoPanel from "../components/RightPannel";
import SelectForm from "./SelectForm";
import { Outlet } from "react-router-dom";
const SelectUser = () => {
  return (
    <div className="">
      {/* <SelectForm />
      <InfoPanel parent="login" /> */}
      <InfoPanel parent="signup">
        <SelectForm />
      </InfoPanel>
      <Outlet />
    </div>
  );
};

export default SelectUser;
